"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActSnackbar;
var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar/Snackbar.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ActSnackbar({
  actAsUser,
  removeUser
}) {
  const action = /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      size: "small",
      "aria-label": "close",
      color: "inherit",
      onClick: removeUser,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {
        fontSize: "small"
      })
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDraggable.default, {
    bounds: "parent",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Snackbar.default, {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      open: actAsUser ? true : false,
      onClose: removeUser,
      message: 'Acting as ' + actAsUser?.userId,
      action: action,
      ClickAwayListenerProps: {
        onClickAway: () => null
      }
    })
  });
}